(function() { window.GUID_38f2376b_c7f7_4c2b_b1da_184dbb992bca = { getGuid: function() { return "38f2376b-c7f7-4c2b-b1da-184dbb992bca"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EventAndPersonaSubtopFormat;
        (function (EventAndPersonaSubtopFormat) {
            EventAndPersonaSubtopFormat[EventAndPersonaSubtopFormat["EventAndPersona"] = 0] = "EventAndPersona";
            EventAndPersonaSubtopFormat[EventAndPersonaSubtopFormat["EventOnly"] = 1] = "EventOnly";
            EventAndPersonaSubtopFormat[EventAndPersonaSubtopFormat["PersonaOnly"] = 2] = "PersonaOnly";
        })(EventAndPersonaSubtopFormat = Enumeration.EventAndPersonaSubtopFormat || (Enumeration.EventAndPersonaSubtopFormat = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EventAndPersonaSubtopFormat.pre.js.map
